import { createApi } from "@reduxjs/toolkit/query/react";

import { ROUTE_WAITLIST_REGISTER, ROUTE_WAITLIST_STATUS } from "../constants";
import { abfSerializeQueryArgs, rubyBaseQuery } from "./util";
import { WaitlistKind, WaitlistStatusResponse } from "../types";

const WAITLIST_TAG = "Waitlist" as const;

export const waitlistApi = createApi({
    reducerPath: "waitlistApi",
    tagTypes: [WAITLIST_TAG],
    baseQuery: rubyBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,
    endpoints: (builder) => ({
        waitlistStatus: builder.query<WaitlistStatusResponse, { kind: WaitlistKind }>({
            providesTags: (_result, _error, arg) => [{ type: WAITLIST_TAG, id: arg.kind }],
            query({ kind }) {
                return {
                    url: ROUTE_WAITLIST_STATUS,
                    method: "GET",
                    params: { waitlistKind: kind }
                };
            }
        }),
        registerWaitlist: builder.mutation<WaitlistStatusResponse, { kind: WaitlistKind }>({
            invalidatesTags: (_result, _error, arg) => [{ type: WAITLIST_TAG, id: arg.kind }],
            query({ kind }) {
                return {
                    url: ROUTE_WAITLIST_REGISTER,
                    method: "POST",
                    body: { waitlistKind: kind }
                };
            }
        })
    })
});

export const { useWaitlistStatusQuery, useRegisterWaitlistMutation } = waitlistApi;
